<template>
  <div class="card mat10">
    <div style="border-bottom:1px solid #E6E6E6;padding:10px 20px 20px 20px">
      <div class="flex-s-c">
        <div class="flex-s-c">
          <!-- // 1待开始 2 进行中 3 未完成 4已完成 5 待取消 6已取消 -->
          <!-- <template v-if="detail.status==1">
            <i class="iconfont icon-order status-iconfont"></i>
            <span class="status-text">待开始</span>
          </template>
          <template v-if="detail.status==2">
            <i class="iconfont icon-shenhezhong1 status-iconfont"></i>
            <span class="status-text">进行中</span>
          </template>
          <template v-if="detail.status==3">
            <i class="iconfont icon-shenhezhong status-iconfont"></i>
            <span class="status-text">审核中</span>
          </template>
          <template v-if="detail.status==4">
            <i class="iconfont icon-yiwancheng status-iconfont"></i>
            <span class="status-text">已完成</span>
          </template>
          <template v-if="detail.status==6">
            <i class="iconfont icon-weiwanchengrenwushu status-iconfont"></i>
            <span class="status-text">已取消</span>
          </template>
          <template v-if="detail.status==5">
            <i class="iconfont icon-order status-iconfont"></i>
            <span class="status-text">待取消</span>
          </template> -->
          <!-- 审核结果 0待审核 1已拒绝 2已通过 -->
          <template v-if="detail.status==0">
            <i class="iconfont icon-shenhezhong status-iconfont"></i>
            <span class="status-text">审核中 </span>
          </template>
          <template v-else-if="detail.status==2">
            <i class="iconfont icon-yiwancheng status-iconfont"></i>
            <span class="status-text">已通过</span>
          </template>
          <template v-else>
            <i class="iconfont icon-weiwanchengrenwushu status-iconfont"></i>
            <span class="status-text">已驳回</span>
          </template>
        </div>
        <div style="text-align: center;margin-left:60px">
          <div class="fontcolor-grey ">申请时间：{{detail.createTime}}</div>
        </div>
      </div>
    </div>
    <template v-for="item in messageList">
      <div class="title-border">
        <span class="name">{{item.title}}</span>
      </div>
      <ul class="key-value">
        <li v-for="cItem in item.fieldList">
          <div class="key">{{cItem.taskFieldKey}}：</div>
          <div class="value">{{cItem.taskFieldValue}}</div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import mModal from '@/components/modal/modal.vue'
export default {
  components: {
    mModal
  },
  data() {
    return {
      messageList: [],
      detail: {}
    };
  },
  computed: {},
  watch: {},
  methods: {
    getDetail() {
      this.$api.getExhibitionApplicationDetail({ id: this.$route.params.id }).then(res => {
        // console.log(res)
        this.detail = res.data
        this.messageList = res.data.detailList
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDetail()
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
</style>
